import React, { useEffect, useState } from 'react'
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFViewer,
Font,
  Image,
} from '@react-pdf/renderer'
//@ts-ignore
import font from '../../assets/fonts/OpenSauceSans-Bold.ttf'
import { DateTime } from 'luxon'
import { formatPipe } from '../../utils/utils'
import sinDerechoCredito from '../../assets/images/sin-derecho-credito.png'
import copiaAnulada from '../../assets/images/copia-anulada.jpg'

const dt = DateTime.local()

const PdfSale: React.FC<IPdfSale> = ({data, subTotal, descuento, igtf, exempt = "0.00", iva, total, client, paidOut, invoiceNumber, creditNote, debitNote, 
  isFromHistory = false,
  type = "INVOICE",
  image,
  baseImponible = "0.00",
  ivaSuntuario = "0.00",
  baseImponibleSuntuario = "0.00",
  reducedIVA = "0.00",
  reducedTaxableBase = "0.00",
  date = null,
  cancelled = false}) => {
  Font.register({
    family: 'Open Sans',
    fonts: [{ src: font }],
  })

  const getDate = () => {
    if (date) {
      const [day, month, year] = date.split("/")
      return `${+day < 10 ? 0 : ''}${day}/${+month < 10 ? 0 : ''}${month}/${year}`
    }
    return dt.toFormat("dd/MM/yyyy")
  }
  
  // const [data, setData] = useState([
  //   {
  //     amount: 1,
  //     description:
  //       'fiewoifeiowfewfiewofiewoifewfhewfoiwiefefewfewfefefewewfgregeweuifhuiefhueiwfuihewfuiewufuiewfhihewf',
  //     n1: 900,
  //     n2: 900,
  //   },
  //   {
  //     amount: 1,
  //     description:
  //       'fiewoifeiowfewfiewofiewoifewfhewfoiwiefefewfewfefefewewfgregeweuifhuiefhueiwfuihewfuiewufuiewfhihewf',
  //     n1: 900,
  //     n2: 900,
  //   },
  //   {
  //     amount: 1,
  //     description:
  //       'fiewoifeiowfewfiewofiewoifewfhewfoiwiefefewfewfefefewewfgregeweuifhuiefhueiwfuihewfuiewufuiewfhihewf',
  //     n1: 900,
  //     n2: 900,
  //   },
  //   {
  //     amount: 1,
  //     description:
  //       'fiewoifeiowfewfiewofiewoifewfhewfoiwiefefewfewfefefewewfgregeweuifhuiefhueiwfuihewfuiewufuiewfhihewf',
  //     n1: 900,
  //     n2: 900,
  //   },
  //   {
  //     amount: 1,
  //     description:
  //       'fiewoifeiowfewfiewofiewoifewfhewfoiwiefefewfewfefefewewfgregeweuifhuiefhueiwfuihewfuiewufuiewfhihewf',
  //     n1: 900,
  //     n2: 900,
  //   },
  //   {
  //     amount: 1,
  //     description:
  //       'fiewoifeiowfewfiewofiewoifewfhewfoiwiefefewfewfefefewewfgregeweuifhuiefhueiwfuihewfuiewufuiewfhihewf',
  //     n1: 900,
  //     n2: 900,
  //   },
  //   {
  //     amount: 1,
  //     description:
  //       'fiewoifeiowfewfiewofiewoifewfhewfoiwiefefewfewfefefewewfgregeweuifhuiefhueiwfuihewfuiewufuiewfhihewf',
  //     n1: 900,
  //     n2: 900,
  //   },
  //   {
  //     amount: 1,
  //     description:
  //       'fiewoifeiowfewfiewofiewoifewfhewfoiwiefefewfewfefefewewfgregeweuifhuiefhueiwfuihewfuiewufuiewfhihewf',
  //     n1: 900,
  //     n2: 900,
  //   },
  //   {
  //     amount: 1,
  //     description:
  //       'fiewoifeiowfewfiewofiewoifewfhewfoiwiefefewfewfefefewewfgregeweuifhuiefhueiwfuihewfuiewufuiewfhihewf',
  //     n1: 900,
  //     n2: 900,
  //   },
  //   {
  //     amount: 1,
  //     description:
  //       'fiewoifeiowfewfiewofiewoifewfhewfoiwiefefewfewfefefewewfgregeweuifhuiefhueiwfuihewfuiewufuiewfhihewf',
  //     n1: 900,
  //     n2: 900,
  //   },
  //   {
  //     amount: 1,
  //     description:
  //       'fiewoifeiowfewfiewofiewoifewfhewfoiwiefefewfewfefefewewfgregeweuifhuiefhueiwfuihewfuiewufuiewfhihewf',
  //     n1: 900,
  //     n2: 900,
  //   },
  //   {
  //     amount: 1,
  //     description:
  //       'fiewoifeiowfewfiewofiewoifewfhewfoiwiefefewfewfefefewewfgregeweuifhuiefhueiwfuihewfuiewufuiewfhihewf',
  //     n1: 900,
  //     n2: 900,
  //   },
  //   {
  //     amount: 1,
  //     description:
  //       'fiewoifeiowfewfiewofiewoifewfhewfoiwiefefewfewfefefewewfgregeweuifhuiefhueiwfuihewfuiewufuiewfhihewf',
  //     n1: 900,
  //     n2: 900,
  //   },
  //   {
  //     amount: 1,
  //     description:
  //       'fiewoifeiowfewfiewofiewoifewfhewfoiwiefefewfewfefefewewfgregeweuifhuiefhueiwfuihewfuiewufuiewfhihewf',
  //     n1: 900,
  //     n2: 900,
  //   },
  //   {
  //     amount: 1,
  //     description:
  //       'fiewoifeiowfewfiewofiewoifewfhewfoiwiefefewfewfefefewewfgregeweuifhuiefhueiwfuihewfuiewufuiewfhihewf',
  //     n1: 900,
  //     n2: 900,
  //   },
  //   {
  //     amount: 1,
  //     description:
  //       'fiewoifeiowfewfiewofiewoifewfhewfoiwiefefewfewfefefewewfgregeweuifhuiefhueiwfuihewfuiewufuiewfhihewf',
  //     n1: 900,
  //     n2: 900,
  //   },
  //   {
  //     amount: 1,
  //     description:
  //       'fiewoifeiowfewfiewofiewoifewfhewfoiwiefefewfewfefefewewfgregeweuifhuiefhueiwfuihewfuiewufuiewfhihewf',
  //     n1: 900,
  //     n2: 900,
  //   },
  //   {
  //     amount: 1,
  //     description:
  //       'fiewoifeiowfewfiewofiewoifewfhewfoiwiefefewfewfefefewewfgregeweuifhuiefhueiwfuihewfuiewufuiewfhihewf',
  //     n1: 900,
  //     n2: 900,
  //   },
  //   {
  //     amount: 1,
  //     description:
  //       'fiewoifeiowfewfiewofiewoifewfhewfoiwiefefewfewfefefewewfgregeweuifhuiefhueiwfuihewfuiewufuiewfhihewf',
  //     n1: 900,
  //     n2: 900,
  //   },
  //   {
  //     amount: 1,
  //     description:
  //       'fiewoifeiowfewfiewofiewoifewfhewfoiwiefefewfewfefefewewfgregeweuifhuiefhueiwfuihewfuiewufuiewfhihewf',
  //     n1: 900,
  //     n2: 900,
  //   }
  // ])

  const styles = StyleSheet.create({
    firstLineContainer: {
      display: 'flex',
      flexDirection: 'row',
      marginBottom: 10,
      height: 35,
    },
    flexRowContainer: {
      display: 'flex',
      flexDirection: 'row',
    },
    rightContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    informationContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: 5,
    },
    cellContainer: {
      padding: 2,
      borderTopWidth: 3,
      borderBottomWidth: 3,
      borderLeftWidth: 3,
      borderColor: 'black',
      borderStyle: 'solid',
    },
    columnText: {
      textAlign: 'center',
    },
    lineContainer: {
      width: '100%',
      height: 3,
      backgroundColor: 'black',
      // marginLeft: 30,
      // marginRight: 90
    },
    amountContainer: {
      position: 'relative',
      bottom: 20,
      width: '100%',
    },
    title: {
      fontSize: 10,
    },
    valueTitle: {
      fontFamily: 'Open Sans',
      fontSize: 10,
    },
    page: {
      padding: 30,
      position: 'relative',
    },
    backgroundImage: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      opacity: 0.1, // Adjust transparency here (0.0 to 1.0)
      zIndex: -1,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    contentContainer: {
      position: 'relative',
      zIndex: 1,
    }
  })

  return (
    <PDFViewer height="100%" width="100%">
      <Document title={`${type === 'BUDGET' ? '' : invoiceNumber ? 'Factura' : creditNote ? 'Nota de crédito' : 'Nota de débito'}-${type === 'BUDGET' ? client.rif : invoiceNumber || creditNote || debitNote}`}>
        <Page size="A4" style={styles.page}>
          {/* Background Image */}

          { isFromHistory && (
            <View style={styles.backgroundImage}>
             <Image
                src={cancelled ? copiaAnulada : sinDerechoCredito}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: 'contain',
                  opacity: 0.1
                }}
              />
            </View>
          )}

          {/* Wrap all existing content in a container */}
          <View style={styles.contentContainer}>
         
         
          
            {/* Move your existing header image here if you want to keep it */}
            {image && (
              <View style={{display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
                <Image 
                  src={image} 
                  style={{objectFit: 'contain', width: 80, height: 80}} 
                />
              </View>
            )}
            
            <View style={{...styles.firstLineContainer, marginTop: type === 'BUDGET' ? 10 : 100}}>
              <View
                style={{
                  ...styles.flexRowContainer,
                  flexBasis: '50%',
                  alignItems: 'center',
                }}
              >
                <View style={{ ...styles.flexRowContainer, flex: 1 }}>
                  <Text style={{ marginRight: 10, ...styles.title }}>
                    RAZÓN SOCIAL:
                  </Text>
                  <Text style={{ ...styles.valueTitle, flex: 1 }}>
                    {client?.name}
                  </Text>
                </View>
              </View>

              <View style={{ ...styles.rightContainer, marginLeft: '10%' }}>
                { type === 'INVOICE' && (
                <View style={styles.flexRowContainer}>
                  <Text style={{ ...styles.title, marginRight: 5 }}>
                    {invoiceNumber ? 'Nro. Documento' : creditNote ? 'Nota de crédito' : 'Nota de débito'}:
                  </Text>
                  <Text style={styles.valueTitle}>{invoiceNumber || creditNote || debitNote}</Text>
                </View>
                ) }

                <View style={{...styles.flexRowContainer, marginTop: type === 'BUDGET' ? 12 : 0}}>
                  <Text style={{ ...styles.title, marginRight: 5 }}>RIF:</Text>
                  <Text style={styles.valueTitle}>{client.rif}</Text>
                </View>
              </View>
            </View>

            <View
              style={{
                ...styles.flexRowContainer,
                marginBottom: 10,
                width: '80%',
              }}
            >
              <Text style={{ marginRight: 10, ...styles.title }}>DIRECCIÓN FISCAL:</Text>
              <Text style={{ ...styles.valueTitle, flex: 1 }}>
                {client?.address}
              </Text>
            </View>

            <View style={styles.informationContainer}>
              <View style={styles.flexRowContainer}>
                <Text style={{ marginRight: 5, ...styles.title }}>Telf:.</Text>
                <Text style={styles.valueTitle}>{client?.phone}</Text>
              </View>

              {/* <View style={styles.flexRowContainer}>
                <Text style={{ marginRight: 5, ...styles.title }}>Ciudad:</Text>
                <Text style={styles.valueTitle}>{client.city}</Text>
              </View>

              <View style={styles.flexRowContainer}>
                <Text style={{ marginRight: 5, ...styles.title }}>Estado:</Text>
                <Text style={styles.valueTitle}>{client?.state}</Text>
              </View> */}
            </View>

            <View style={styles.flexRowContainer}>
              {/* { type === 'INVOICE' && (
              <View style={{ ...styles.flexRowContainer, flexBasis: '60%' }}>
                <Text style={{ marginRight: 5, ...styles.title }}>
                  Condición de pago:
                </Text>
                <Text style={styles.valueTitle}>{paidOut ? 'CONTADO' : 'CRÉDITO'}</Text>
              </View>
              ) } */}

              <View style={styles.flexRowContainer}>
                <Text style={{ marginRight: 5, ...styles.title }}>Fecha:</Text>
                <Text style={styles.valueTitle}>{type === 'BUDGET' ? date: getDate()}</Text>
                {/* <Text style={styles.valueTitle}>{dt.toLocaleString({day: '2-digit', month: '2-digit', year: 'numeric'})}</Text> */}
              </View>
            </View>

            <View style={styles.flexRowContainer}>
              <View style={{ ...styles.cellContainer, flexBasis: '10%' }}>
                <Text style={{ ...styles.valueTitle, textAlign: 'center' }}>
                  Cant.
                </Text>
              </View>
              <View style={{ ...styles.cellContainer, flexBasis: '50%' }}>
                <Text style={{ ...styles.valueTitle, textAlign: 'center' }}>
                  Descripción
                </Text>
              </View>
              <View style={{ ...styles.cellContainer, flexBasis: '20%' }}>
                <Text style={{ ...styles.valueTitle, textAlign: 'center' }}>
                  P.U. (Bs.)
                </Text>
              </View>
              <View
                style={{
                  ...styles.cellContainer,
                  borderRightWidth: 2,
                  flexBasis: '20%',
                }}
              >
                <Text style={{ ...styles.valueTitle, textAlign: 'center' }}>
                  Total (Bs.)
                </Text>
              </View>
            </View>

            {data && data.map((row) => (
              <View style={{ ...styles.flexRowContainer, marginTop: 10 }}>
                <View
                  style={{
                    flexBasis: '10%',
                    ...styles.flexRowContainer,
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Text style={styles.title}>{row.amount}</Text>
                </View>

                <View
                  style={{
                    flexBasis: '50%',
                    ...styles.flexRowContainer,
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Text style={styles.title}>
                    {row.description.length > 56
                      ? `${row.description.slice(0, 56)}...`
                      : row.description}
                  </Text>
                </View>

                <View
                  style={{
                    flexBasis: '20%',
                    ...styles.flexRowContainer,
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Text style={styles.title}>{formatPipe(row.individualPrice.toFixed(2))}</Text>
                </View>

                <View
                  style={{
                    flexBasis: '20%',
                    ...styles.flexRowContainer,
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Text style={styles.title}>{formatPipe(row.totalPrice.toFixed(2))}</Text>
                </View>
              </View>
            ))}

            <View style={{ ...styles.lineContainer, marginBottom: 15, marginTop: 10 }}></View>
            <View style={styles.amountContainer}>
              <View
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-end',
                  padding: 10,
                }}
              >
                <View style={{ ...styles.flexRowContainer, marginBottom: 10 }}>
                  <Text style={{ marginRight: 5, ...styles.valueTitle }}>
                    Subtotal:
                  </Text>
                  <Text style={{ ...styles.valueTitle }}>{formatPipe(subTotal)}</Text>
                </View>

                
                <View style={{ ...styles.flexRowContainer, marginBottom: 10 }}>
                  <Text style={{ marginRight: 5, ...styles.valueTitle }}>
                    Monto exento:
                  </Text>
                  <Text style={{ ...styles.valueTitle }}>{formatPipe(exempt)}</Text>
                </View>

                { descuento !== '0.00' && (
                <View style={{ ...styles.flexRowContainer, marginBottom: 10 }}>
                  <Text style={{ marginRight: 5, ...styles.valueTitle }}>
                    Descuento:
                  </Text>
                  <Text style={{ ...styles.valueTitle }}>{formatPipe(descuento)}</Text>
                </View>
                )}

                <View style={{ ...styles.flexRowContainer, marginBottom: 10 }}>
                  <Text style={{ marginRight: 5, ...styles.valueTitle }}>
                    Base imponible I.V.A general 16%:
                  </Text>
                  <Text style={{ ...styles.valueTitle }}>{formatPipe(baseImponible)}</Text>
                </View>


                <View style={{...styles.flexRowContainer, marginBottom: 10}}>
                  <Text style={{ marginRight: 5, ...styles.valueTitle }}>
                    I.V.A General 16%:
                  </Text>
                  <Text style={{ ...styles.valueTitle }}>{formatPipe(iva)}</Text>
                </View>

                { ivaSuntuario !== '0.00' && (
                <View style={{ ...styles.flexRowContainer, marginBottom: 10 }}>
                  <Text style={{ marginRight: 5, ...styles.valueTitle }}>
                    Base imponible I.V.A suntuario 15%:
                  </Text>
                  <Text style={{ ...styles.valueTitle }}>{formatPipe(baseImponibleSuntuario)}</Text>
                </View>
                ) }

                { ivaSuntuario !== '0.00' && (
                <View style={{...styles.flexRowContainer, marginBottom: 10}}>
                  <Text style={{ marginRight: 5, ...styles.valueTitle }}>
                    I.V.A Suntuario 15%:
                  </Text>
                  <Text style={{ ...styles.valueTitle }}>{formatPipe(ivaSuntuario)}</Text>
                </View>
                ) }

                { reducedIVA !== '0.00' && (  
                <View style={{ ...styles.flexRowContainer, marginBottom: 10 }}>
                  <Text style={{ marginRight: 5, ...styles.valueTitle }}>
                    Base imponible I.V.A reducido 8%:
                  </Text>
                  <Text style={{ ...styles.valueTitle }}>{formatPipe(reducedTaxableBase)}</Text>
                </View>
                ) }

                { reducedIVA !== '0.00' && (
                <View style={{...styles.flexRowContainer, marginBottom: 10}}>
                  <Text style={{ marginRight: 5, ...styles.valueTitle }}>
                    I.V.A Reducido 8%:
                  </Text>
                  <Text style={{ ...styles.valueTitle }}>{formatPipe(reducedIVA)}</Text>
                </View>
                ) }

                { type === 'INVOICE' && invoiceNumber && (
                <View style={{ ...styles.flexRowContainer }}>
                  <Text style={{ marginRight: 5, ...styles.valueTitle }}>
                    IGTF:
                  </Text>
                  <Text style={{ ...styles.valueTitle }}>{formatPipe(igtf)}</Text>
                </View>
                ) }
              </View>

              <View style={styles.lineContainer}></View>

              <View
                style={{
                  ...styles.flexRowContainer,
                  justifyContent: 'flex-end',
                  padding: 10,
                }}
              >
                <Text style={{ marginRight: 5, ...styles.valueTitle }}>
                  Total:
                </Text>
                <Text style={{ ...styles.valueTitle }}>{formatPipe(total)}</Text>
              </View>

              <View style={styles.lineContainer}></View>
            </View>
          </View>
        </Page>
      </Document>
    </PDFViewer>
  )
}

interface Data {
  amount: string
  description: string
  individualPrice: number
  totalPrice: number
}

interface Client {
  name: string | undefined
  address: string | undefined
  phone: string | undefined
  state: string | undefined
  city: string | undefined
  rif: string | undefined
}

interface IPdfSale {
  data: Data[] | undefined
  subTotal: string
  descuento: string
  igtf: string
  iva: string
  baseImponible?: string
  ivaSuntuario?: string
  baseImponibleSuntuario?: string
  reducedIVA?: string
  reducedTaxableBase?: string
  exempt?: string
  total: string
  client: Client
  paidOut: boolean
  invoiceNumber?: string
  creditNote?: string
  debitNote?: string
  date?: any
  type?: "INVOICE" | "BUDGET"
  image?: string | undefined | null
  isFromHistory?: boolean
  cancelled?: boolean
}

export default PdfSale
